import useTranslation from "next-translate/useTranslation";
import { FaCheck } from "react-icons/fa";
import styles from "../register/styles/Register.module.css";
import { getTierBenefits, getTierName } from "./tierBenefits";

type PremiumWelcomeSummaryProps = {
  tier: number;
};

export default function PremiumWelcomeSummary({
  tier,
}: PremiumWelcomeSummaryProps) {
  const { t } = useTranslation("common");
  const benefits = getTierBenefits(t, tier);
  const tierName = getTierName(tier);

  return (
    <div className="w-full max-w-[560px] px-4 pt-8 pb-6 text-center">
      <div className={`${styles.doneCheck} mx-auto`}>
        <FaCheck />
      </div>
      <h1 className="mt-4 text-2xl font-bold">{t("Welcome to Premium!")}</h1>
      {benefits.length > 0 && (
        <>
          <div className="mt-1 text-sm font-semibold tracking-wide text-altgray-500">
            {tierName}
          </div>
          <div className="mx-auto mt-5 text-center">
            <ul className="mx-auto w-fit max-w-[420px] space-y-2 list-disc pl-6 text-left text-altgray-700">
              {benefits.map((benefit) => (
                <li key={benefit}>{benefit}</li>
              ))}
            </ul>
          </div>
        </>
      )}
    </div>
  );
}
